import { Component, OnInit, inject, DestroyRef } from '@angular/core';
import { UserService } from '../../../services/http/user/user.service';
import { DataService } from '../../../services/store/data.service';
import { StoreSummary } from '../../../classes/models/store/StoreSummary';
import { UserSummary } from '../../../classes/models/user/UserSummary';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SHARED_IMPORTS } from '../../../shared/standalone-imports';

/**
 * This component shows a list of users.
 */
@Component({
    selector: 'app-users',
    templateUrl: './users.component.html',
    styleUrls: ['./users.component.less'],
    imports: [SHARED_IMPORTS]
})
export class UsersComponent implements OnInit {
  private userService = inject(UserService);
  dataService = inject(DataService);
  private destroyRef = inject(DestroyRef);
  private destroy$ = new Subject<void>();

  constructor() {
    this.destroyRef.onDestroy(() => {
      this.destroy$.next();
      this.destroy$.complete();
    });
  }


  /** A list of all user summarized information. */
  userSummaries: UserSummary[] = [];
  /** The store, which is currently selected. */
  selectedStore: StoreSummary;
  /** A text by which user list is filtered. */
  searchModel: string;
  /** The page of the pagination. */
  page = 1;
  /** The maximum items showed in one page. */
  pageSize = 45;

  /**
   * Sets up all data on page initialization.
   */
  ngOnInit(): void {
    this.getUserSummaries();
    this.selectedStore = this.dataService.selectedStore;
  }

  private getUserSummaries(): void {
    this.userService.getUserSummaries()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: users => this.userSummaries = users
      });
  }
}
